import { CotopaxiPaddings } from './CommonTypes';

export type LoginContainerProps = {
  paddings?: CotopaxiPaddings;
  redirectLink?: string;
  hideTitle: boolean;
};
